<template>
    <div>


        <b-row>

            

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Inventário
                </label>
                  <b-form-select id="inventory"
                    v-model="selectedInventoryId"
                    :plain="true"
                    :options="inventoryDDL"
                    @change="refreshData"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <!--
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>
            -->

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage"></label>
                  <b-form-group>
                    <b-button variant="github" class="mr-1 btn-brand" @click="openModal(null)"><i class="fa fa-plus"></i><span>Nova Faixa de Etiquetas</span></b-button>
                  </b-form-group>
                </b-form-group>
            </b-col>
            
        </b-row>
        
          
        <b-form>
            <div class="animated fadeIn">                
                
            <b-row>
                <b-col md="12">
                
                <b-table :items="items"
                    :fields="categoryTable.fields" 
                    :select-mode="categoryTable.selectMode" 
                    responsive="sm" 
                    primary-key="id" 
                    :tbody-transition-props="categoryTable.transProps" 
                    sort-icon-left
                    @row-clicked="rowClicked"
                    per-page="50" 
                    current-page="1" 
                    :busy="categoryTable.isBusy" 
                    hover striped                    
                    >

                    <template #table-busy>
    
                    <div class="text-center text-danger my-2">
    
                        <b-spinner class="align-middle"></b-spinner>
    
                        <strong>Carregando...</strong>
    
                    </div>
                    </template>
                                
                    <!-- Example scoped slot for select state illustrative purposes -->
                    <template #cell(selected)="{ rowSelected }">
                        <template v-if="rowSelected">
                        
                                        <span aria-hidden="true">&check;</span>
                        
                                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        
                        <span class="sr-only">Not selected</span>
                    </template>
                                </template>

                    
                    <template v-slot:cell(action)="data">
                        <b-button size="sm" variant="danger" @click="openDeleteModal(data.item)" class="mr-1 btn-brand"><i class="fa fa-close"></i></b-button>
                    </template>

                    <template v-slot:cell(st)="data">
                        <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" />
                    </template>
                                
                                
                </b-table>
                
                </b-col>
            </b-row>

            </div>
        </b-form>

        <b-modal
            v-model="modal"
            id="modal"
            centered
            hide-footer
            title="Etiquetas"
            size="lg">
            <b-card>

                <b-form @submit.stop.prevent="onSubmit">
                
                <div class="animated fadeIn">

                    <b-row>
                        <b-col md="12">
                            <b-form>
                            <b-form-group
                            description=""
                            label="Inicial"
                            label-for="name"
                            :label-cols="2"
                            :horizontal="true">
                                <b-row>
                                    <b-col><b-form-input v-model="labelStart" id="labelStart" type="number" ></b-form-input></b-col>
                                    <b-col lg="2">Final: </b-col>
                                    <b-col><b-form-input v-model="labelEnd" id="labelEnd" type="number" ></b-form-input></b-col>
                                </b-row>
                                
                            </b-form-group>          
                            </b-form>
                        </b-col>
                    </b-row>

                
                    <div slot="footer" class="text-right">
                    <!--
                    <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                    <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                    -->
                    <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Faixa de Etiqueta</span></b-button>
                    
                    </div>
                        
                </div>
                </b-form>

            </b-card>
        </b-modal>

        <b-modal title="Excluir Selecionados" class="modal-delete" v-model="deleteModal" @ok="deleteItem" cancel-title="Cancelar" >
            Deseja realmente excluir a faixa de etiquetas selecionada?
        </b-modal>
        
    </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
import InventorySectorLabel from './InventorySectorLabel'

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
}

const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'InventoryStockLabel',
    props: {
        companyId: Number,
        stockLocationId: Number,
        inventoryId: Number,
        inventoryDDL: Array
        
    },
    watch: {
        inventoryId: {
            immediate: true,
            handler(newValue) {
                
                this.selectedInventoryId = newValue ? newValue : 0
            }
        },
    },
    components: {
       
    },
    data: () => {
        return {

            labelStart: null,
            labelEnd: null,

            selectedInventoryId: 0,
            selectedItem: null,
            modal: false,
            deleteModal: false,
            items: [],
            categoryTable: {
                isBusy: false,
                fields: [
                    { key: 'labelStart', label: 'Inicial', sortable: true },
                    { key: 'labelEnd', label: 'Final', sortable: true },
                    { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
                ],
                selectMode: 'single', 
                transProps: {
                    name: 'flip-list'
                }
            }

        }
    },
    methods: {
        async deleteItem() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            if(this.selectedItem && this.selectedItem.id && this.selectedItem.id > 0) {
                axios.delete(
                    this.$store.state.ws_url + "/stock/location/label?id=" + this.selectedItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                ).then(function(resp) {
                    s.refreshData()
                    s.closeDeleteModal()
                }).catch(function(error) {
                    s.closeDeleteModal()
                })
            }

        },
        async saveItem() {
            var s = this;
            var postData = {};

            postData["stockLocationId"] = s.stockLocationId,
            postData["inventoryId"] = s.inventoryId,
            postData["labelStart"] = s.labelStart,
            postData["labelEnd"] = s.labelEnd,
            postData["uid"] = this.$store.state.currentUser.id,
            postData["sid"] = this.$store.state.currentUser.sid

            await axios.post(
                this.$store.state.ws_url + "/stock/location/label",
                postData
            ).then(function() {
                s.closeModal()
                s.refreshData()
            }
            ).catch(function (error) {
                console.log(error);
                toast ({
                    type: VueNotifications.types.warn,
                    title: 'Setor',
                    message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
                    timeout: 5000
                })        
            });
        },
        save() {
            let msgError = [];

            if(!this.labelStart)
                msgError.push("Inicial");
            if(!this.labelEnd)
                msgError.push("Final");

            if(msgError.length > 0) {
                let msgErrorExt = "Verifique os campos: ";
                let msgErrorSep = "";
                msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

                toast ({
                    type: VueNotifications.types.error,
                    title: 'Etiqueta',
                    message: msgErrorExt,
                    timeout: 5000
                })
            }
            else {
                this.saveItem();
            }
        },
        rowClicked(item) {
            console.log("Linha clicada")
            this.selectedItem = item
        },
        openDeleteModal(item) {
            this.selectedItem = item
            this.deleteModal = true
        },
        closeDeleteModal() {
            this.deleteModal = false
        },
        openModal() {
            this.modal = true
        },
        closeModal() {
            this.modal = false
        },
        async refreshData() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            
            if(this.stockLocationId && this.inventoryId && this.stockLocationId > 0 && this.inventoryId > 0) {
              
                await axios.get(
                    this.$store.state.ws_url + "/stock/location/label?stockLocationId=" + s.stockLocationId + "&inventoryId=" + s.selectedInventoryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                ).then(function(resp) {
                    s.items = resp.data.obj;
                })            
                .catch(function(error) {
                    console.log(error);
                });     
            }
            else {
                s.items = []
            }
               
        }    
    },
    mounted: function() {
        this.refreshData()
    }
}
</script>